<template>
  <div>
    <form @submit.prevent="createUpdateDevice" v-if="request">
      <modal v-show="isModalVisible" @close="closeModal" footer>
        <template v-slot:title>
          <h5>
            Update Request
          </h5>
        </template>
        <template v-slot:body>
          <div class="form-group">
            <label for="status">Status</label>
            <br />
            <select
              id="select"
              class="form-select fw-two form-control"
              v-model="request.status"
            >
              <option value selected disabled>Status</option>
              <option
                value="pending"
                class="mb-2"
                :selected="terminal_status == 'pending'"
                :disabled="terminal_status != 'pending'"
                >Pending</option
              >
              <option
                value="approved"
                class="mb-2"
                :selected="request.status == 'approved'"
                >Approved</option
              >
              <option
                value="rejected"
                class="mb-2"
                :selected="request.status == 'rejected'"
                >Rejected</option
              >
            </select>
          </div>
          <div class="form-group">
            <label for="title">Request Reference</label>
            <input
              type="text"
              class="form-control"
              name="title"
              v-model="request.terminal_request_reference"
              readonly
            />
          </div>
          <div class="form-group">
            <label for="title">No of Terminal Request</label>
            <input
              type="text"
              class="form-control"
              name="title"
              v-model="request.no_of_terminal_request"
              readonly
              disabled
            />
          </div>
          <div class="form-group">
            <label for="title">Requested By</label>
            <input
              type="text"
              class="form-control"
              name="title"
              :value="request.user.first_name + ' ' + request.user.last_name"
              readonly
              disabled
            />
          </div>
          <div class="form-group">
            <label for="title">No of terminals Approved</label>
            <input
              type="text"
              class="form-control"
              name="title"
              v-model="request.no_of_terminal_approved"
              :disabled="terminal_status != 'pending'"
            />
          </div>
          <div class="form-group">
            <label for="title">Status Message</label>
            <textarea
              type="text"
              class="form-control"
              name="title"
              v-model="request.status_message"
              :disabled="terminal_status != 'pending'"
            />
          </div>
        </template>
        <template v-slot:footer>
          <button
            type="submit"
            class="button"
            :disabled="loading || !formIsValid"
            v-if="
              terminal_status == 'pending' &&
                permissions.includes('treat-terminal-request')
            "
          >
            <span class="custom-loader" v-if="loading">
              <loader-icon size="1.5x" class="custom-class"></loader-icon>
              <span style="font-weight: 600; text-transform: initial;"
                >Please wait...</span
              >
            </span>
            <span v-else>
              Treat Request
            </span>
          </button>
          <button
            type="button"
            class="btn btn-secondary"
            data-dismiss="modal"
            @click="closeModal"
          >
            Cancel
          </button>
        </template>
      </modal>
    </form>

    <div
      v-if="pageLoading"
      style="display: flex; top: 0px; position: fixed; left: 0px; right: 0px; bottom: 0px; background-color: rgba(247, 247, 247, 0.9); z-index: 9999; justify-content: center; align-items: center;"
    >
      <div>
        <div>
          <h3>Getting Devices ready...</h3>
        </div>
      </div>
    </div>
    <div v-else>
      <div class="row align-items-center justify-content-between mb-2">
        <div class="col">
          <h1 class="mb-2 font-regular">Terminal Request</h1>
        </div>
        <div class="col-auto">
          <!-- <button class="button button--outline text-uppercase" @click="openModal">Add Device</button> -->
        </div>
      </div>

      <div class="card card--no-shadow">
        <div class="card-header">
          <slot name="header">
            <h4 class="card-title">Terminal Request</h4>
          </slot>
        </div>
        <div class="card-content">
          <div class="card-body">
            <CDataTable
              :items="requests"
              :fields="fields"              
              sorter
              tableFilter
            >
              <template #created_at="{item}">
                <td class="table--action-mobile">
                  {{ item.created_at | date }}
                </td>
              </template>
              <template #request_by="{item}">
                <td class="table--action-mobile">
                  {{ item.user.first_name + " " + item.user.last_name }}
                </td>
              </template>
              <template #action="{item}">
                <td class="table--action-mobile">
                  <button
                    v-if="permissions.includes('treat-terminal-request')"
                    class="btn-success btn-sm"
                    style="background-color: #0bc681;"
                    @click="showUpdateModal(item)"
                  >
                    View Request
                  </button>
                  <button v-if="permissions.includes('view-customer')" class=" btn btn-primary btn-sm w-auto"
                    @click="openNewTab(item.user.id)">
                    View Customer
                  </button>
                </td>
              </template>
            </CDataTable>
            <CPagination
              :activePage.sync="next_page"
              :pages="total"
              :onActivePageChange="onPageChange()"
            ></CPagination>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import ApiService from "../../services/api.service";
import ErrorService from "../../services/error.service";
import Swal from "sweetalert2";
import CDataTable from "../../components/CDataTable.vue";
import CPagination from "@/components/CPagination.vue";
const fields = [
  "terminal_request_reference",
  "no_of_terminal_request",
  "request_by",
  "status",
  "created_at",
  "action"
];
export default {
  name: "ChargesSettings",
  components: {
    CDataTable,
    CPagination
  },
  data() {
    return {
      fields,
      terminal_status: "",
      requests: [],
      next_page: 1,
      current: 1,
      total: 1,
      small: true,
      request: null,
      loading: false,
      pageLoading: false,
      isModalVisible: false
    };
  },
  computed: {
    formIsValid() {
      return (
        this.request.status !== "" &&
        this.request.no_of_terminal_approved !== ""
      );
    },
    permissions() {
      let permissions = this.$store.getters.permissions;
      return permissions;
    }
  },
  methods: {
    showUpdateModal(item) {
      this.request = Object.assign({}, item);
      this.terminal_status = item.status;
      this.isModalVisible = true;
    },
    openModal() {
      this.isModalVisible = true;
    },
    closeModal() {
      this.isModalVisible = false;
      this.request = null;
    },

    async getDevices(page) {
      try {
        this.pageLoading = true;
        const response = await ApiService.get(
          `terminal/all-terminal-request?page=${page}`
        );
        this.requests = response.data.data.data;
        this.current = response.data.data.current_page;
        this.total = response.data.data.last_page;
        this.pageLoading = false;
      } catch (error) {
        console.log(error.response);
        this.pageLoading = false;
      }
    },
    onPageChange() {
      if (this.current != this.next_page) {
        this.getDevices(this.next_page);
      }
    },

    async createUpdateDevice() {
      try {
        const response = await ApiService.post(
          "terminal/treat-request",
          this.request
        );
        Swal.fire({
          title: "Success",
          text: response.data.message,
          icon: "success",
          confirmButtonText: "Ok"
        });
        this.getDevices(this.current);
        this.closeModal();
      } catch (error) {
        console.log(error.response);
        this.updateCustomerLoading = false;
        let _error = error.response.data;
        this.closeModal();
        ErrorService.displayErrorAlert(_error);
      }
    },
    popMessage(title, sub_title = "", action = "", parameter = "") {
      Swal.fire({
        title: `${title}`,
        text: `${sub_title}`,
        icon: "warning",
        showCancelButton: true,
        confirmButtonColor: "#3085d6",
        cancelButtonColor: "#d33",
        confirmButtonText: "Yes, I am sure!"
      }).then(result => {
        if (result.isConfirmed) {
        }
      });
    },
    openNewTab(id) {
      const newTabUrl = `/customers/${id}`; // Replace with your desired route path
      window.open(newTabUrl, "_blank");
    },
  },
  mounted() {
    this.getDevices(1);
  }
};
</script>
